module.exports = __webpack_public_path__ + "roboto-light-webfont.869ede0fcd8fbd54e1b5.woff2";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/assets/fonts/roboto-light-webfont.woff2
// module id = ../../../../../src/assets/fonts/roboto-light-webfont.woff2
// module chunks = styles